(function () {
	const contactModal = () => {
		const toggleButton = document.querySelector(".steps_content_button");
		if (toggleButton) {
			toggleButton.addEventListener("click", function () {
				const modal = document.querySelector(".contact-modal");
				if (modal) {
					modal.classList.add("active");
					document.body.classList.add("overflow-hidden");
				}
			});
		}
		const modalOverlay = document.querySelector(".modal__overlay");
		if (modalOverlay) {
			modalOverlay.addEventListener("click", function () {
				const modal = document.querySelector(".contact-modal");
				if (modal) {
					modal.classList.remove("active");
					document.body.classList.remove("overflow-hidden");
				}
			});
		}
		const modalclose = document.querySelector(".close_modal_element");
		if (modalclose) {
			modalclose.addEventListener("click", function () {
				const modal = document.querySelector(".contact-modal");
				if (modal) {
					modal.classList.remove("active");
					document.body.classList.remove("overflow-hidden");
				}
			});
		}
		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				const modal = document.querySelector(".contact-modal");
				if (modal) {
					modal.classList.remove("active");
					document.body.classList.remove("overflow-hidden");
				}
			}
		});
	};
	document.addEventListener("DOMContentLoaded", function () {
		contactModal();
		document.addEventListener("shopify:section:load", function () {
			contactModal();
		});
	});
})();
